<form [formGroup]="form">
  <div class="fields-container">
    <div class="field-control">
      <app-text-field
        [control]="form.get('name')"
        [label]="'ACTIVITY.DESCRIPTION_EN' | translate"
        [validationMessages]="{
          english: 'VALIDATION_MSG.EN_LETTERS' | translate
        }"
      />
    </div>

    <div class="field-control">
      <app-text-field
        [control]="form.get('description')"
        [label]="'ACTIVITY.DESCRIPTION_AR' | translate"
        [validationMessages]="{
          arabic: 'VALIDATION_MSG.AR_LETTERS' | translate
        }"
      />
    </div>
    <!----- SUBMIT actions --------->
    <div class="buttons-group">
      <app-button
        type="button"
        classesName="btn-edge-cut  btn-width-auto"
        [label]="'BUTTONS.ADD' | translate"
        (onBtnClick)="submitActivity()"
      />
      <app-button
        type="button"
        classesName="card-edge-cut-white btn-width-auto"
        [label]="'BUTTONS.CLOSE' | translate"
        (onBtnClick)="close()"
      />
    </div>
  </div>
</form>
